<template>
  <v-dialog
    v-model="internalDialogVisible"
    max-width="822px"
    :fullscreen="isMobileBreakpoint"
    :persistent="false"
    content-class="panda-assist-dialog"
    @input="handleDialogClose"
  >
    <v-card
      flat
      style="height: 533px; max-width: 585px; margin: 0 auto"
      class="d-flex flex-column align-center justify-center"
      v-if="step === 1"
    >
      <simple-svg
        :src="require('@/assets/chat_icon.svg')"
        v-if="step === 1"
        width="80px"
        height="80px"
      />
      <v-card-title>
        <span class="assistHeadline">
          <template>
            <div
              class="text-center body-bold-xlarge neutral-20-dark--text mb-3"
            >
              {{ $t('message.pages.pandaAssist.selectPandaAssist.title') }}
            </div>
          </template>
        </span>
      </v-card-title>
      <v-card-text class="text-center" style="padding: 0; width: 100%">
        <div
          class="border-neutral-95"
          style="
            border-radius: 12px;
            border: 1px solid;
            padding: 10px;
            padding-top: 0;
          "
        >
          <div v-if="data.length" style="max-height: 150px; overflow-x: auto">
            <div v-for="item in data" :key="item.id">
              <div
                @click="selectOption(item)"
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  width: 100%;
                  margin-bottom: 6px;
                  margin-top: 6px;
                  padding: 8px;
                  cursor: pointer;
                "
              >
                <a type="secondary">
                  <span class="body-regular-small neutral-20-dark--text">{{
                    item.name
                  }}</span>
                </a>
                <v-icon class="color-neutral-40-light" style="font-size: 16px"
                  >mdi-arrow-right</v-icon
                >
              </div>
              <v-divider></v-divider>
            </div>
          </div>
          <v-divider v-if="data.length"></v-divider>
          <div>
            <div
              @click="handleClose"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                margin-bottom: 50px;
                margin-top: 6px;
                padding: 8px;
                cursor: pointer;
              "
            >
              <a type="primary">
                {{ $t('message.pages.pandaAssist.emptyState.buttonText') }}
              </a>
              <v-icon class="color-neutral-40-light" style="font-size: 16px"
                >mdi-arrow-right</v-icon
              >
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <div
      v-if="step === 2 && isMobileBreakpoint"
      class="d-flex justify-space-between px-3 pt-4"
    >
      <span class="d-flex">
        <!-- <v-icon
          @click="backStep"
          class="close-icon"
          size="20"
          style="cursor: pointer"
        >
          mdi-arrow-left
        </v-icon> -->
        <div class="body-bold-small">
          <span v-if="step === 2">{{
            $t('message.pages.pandaAssist.createModal.mobileSelectVideos')
          }}</span>
          <span v-if="step === 6">{{
            $t('message.pages.pandaAssist.createModal.mobileCheckoutOverview')
          }}</span>
        </div>
      </span>
      <v-icon
        @click="closeModal"
        class="close-icon ml-auto"
        size="20"
        color="grey"
        style="cursor: pointer"
      >
        mdi-close
      </v-icon>
    </div>
    <v-card class="px-6" flat v-if="step === 2">
      <!-- Etapa 5 -->
      <div :class="isMobileBreakpoint ? 'pa-3' : ''">
        <div class="d-flex mb-6 pt-6">
          <!-- <v-icon
            @click="backStep"
            class="close-icon"
            color="grey"
            size="24"
            style="cursor: pointer; margin-right: 4px"
          >
            mdi-arrow-left
          </v-icon> -->
          <div>
            <v-card-title class="pa-0 ma-0 mb-1">
              <span
                :class="
                  isMobileBreakpoint ? 'body-bold-small' : 'body-bold-medium'
                "
              >
                {{ $t('message.pages.pandaAssist.createModal.selectVideos') }}
              </span>
            </v-card-title>
            <v-card-text
              class="pa-0 textType6--text"
              :class="
                isMobileBreakpoint
                  ? 'body-regular-smaller'
                  : 'body-regular-small,'
              "
            >
              {{
                $t(
                  'message.pages.pandaAssist.createModal.creditExhaustedExplanation'
                )
              }}
              <a target="_blank" type="secondary" :href="embedArticle">
                <span>
                  {{ $t('message.embedModal.knowMore') }}
                </span>
                <v-icon size="12">mdi-open-in-new</v-icon>
              </a>
            </v-card-text>
          </div>
          <v-icon
            v-if="!isMobileBreakpoint"
            @click="closeModal"
            class="close-icon ml-auto"
            size="24"
            color="grey"
            style="cursor: pointer"
          >
            mdi-close
          </v-icon>
        </div>
        <template>
          <small v-for="(item, i) in breadcrumbArray" :key="i">
            <button class="pb-3" type="button" @click="handleBackTo(item)">
              <span :class="i === 0 ? 'body-bold-small' : 'textType6--text'">
                <v-icon
                  v-if="i === 0 && breadcrumbArray.length > 1"
                  class="tableArrow"
                  size="16"
                  color="grey"
                  style="cursor: pointer"
                >
                  mdi-arrow-left
                </v-icon>
                {{
                  item.id
                    ? item.name
                    : $t('message.pages.pandaAssist.createModal.library')
                }}
                <span
                  class="textType6--text px-1"
                  v-if="i < breadcrumbArray.length - 1"
                >
                  /
                </span>
              </span>
            </button>
          </small>
          <small>
            <v-icon v-if="!!selectedFolder">mdi-chevron-right</v-icon>
            <button v-if="!!selectedFolder" type="button" class="primary--text">
              <span class="breadcrumbTexts primary--text">
                {{ selectedFolder.name }}
              </span>
            </button>
          </small>
        </template>

        <v-input
          hide-details="auto"
          class="pb-3"
          prepend-inner-icon="panda-search"
          v-model="searchQuery"
          :placeholder="
            $t('message.pages.pandaAssist.createModal.searchPlaceholder')
          "
        ></v-input>

        <v-row no-gutters>
          <v-card
            class="d-flex align-center ml-1"
            :class="!isMobileBreakpoint ? 'justify-center ' : ''"
            width="50px"
            flat
          >
            <v-simple-checkbox
              :indeterminate="checkboxIndeterminateStatus"
              :value="areAllSelected"
              :ripple="false"
              :disabled="isLoading"
              @input="toggleSelectAll"
            />
          </v-card>
          <v-card
            flat
            :style="{ width: isMobileBreakpoint ? '50px' : '465px' }"
            class="d-flex align-center justify-start"
          >
            <v-row no-gutters>
              <div class="d-flex align-center">
                <span class="body-bold-smaller mr-1">
                  {{ $t('message.pages.videosDataTable.header.name') }}
                </span>
              </div>
            </v-row>
          </v-card>
          <v-card
            v-if="!isMobileBreakpoint"
            class="d-flex align-center"
            height="45px"
            flat
          >
            <span class="body-bold-smaller pr-1">
              {{ $i18next.t('message.pages.videosDataTable.header.time') }}
            </span>
          </v-card>
          <v-card
            v-if="!isMobileBreakpoint"
            style="justify-content: end"
            class="d-flex align-center"
            height="45px"
            flat
            width="170px"
          >
            <div class="d-flex align-center">
              <span class="body-bold-smaller" style="margin-right: 4px">
                Valor
              </span>
            </div>
          </v-card>
        </v-row>
        <vue-virtual-table
          v-if="filteredItems.length > 0"
          ref="dataTableContent"
          class="data-table__content"
          :config="headers"
          :data="filteredItems"
          :height="500"
          :itemHeight="48"
          :minWidth="590"
        >
          <template slot-scope="scope" slot="select">
            <v-row no-gutters align="center" justify="end">
              <v-simple-checkbox
                class="pl-3"
                color="primary"
                :ripple="false"
                :disabled="
                  alreadyHasPandaAssistVideos.includes(scope.row.id) ||
                  scope.row.id == video.id ||
                  isLoading
                "
                :value="checkIfSelected(scope.row)"
                @input="checkboxSelection(scope.row)"
              ></v-simple-checkbox>
            </v-row>
          </template>
          <template slot-scope="scope" slot="titleCommon">
            <v-row
              no-gutters
              align="center"
              class="searchVideosMenuContext flex-nowrap"
              @click="handleItemClick(scope.row)"
            >
              <v-icon class="folderIcon ml-2" v-if="scope.row.name" size="16">
                mdi-folder
              </v-icon>
              <v-icon
                class="ml-2"
                :class="
                  alreadyHasPandaAssistVideos.includes(scope.row.id)
                    ? 'videoIconNeutral'
                    : 'videoIcon'
                "
                v-else
                size="16"
              >
                panda-video
              </v-icon>
              <span
                class="textType6--text ml-2 truncate"
                :class="
                  alreadyHasPandaAssistVideos.includes(scope.row.id)
                    ? 'videoIconNeutral'
                    : ''
                "
                :title="scope.row.name ? scope.row.name : scope.row.title"
              >
                {{ scope.row.name ? scope.row.name : scope.row.title }}
              </span>
            </v-row>
          </template>
          <template slot-scope="scope" slot="durationCommon">
            <v-row
              no-gutters
              align="center"
              justify="end"
              class="searchVideosMenuContext body-regular-smaller"
              @click="handleEnterFolder(scope.row)"
            >
              <span v-if="scope.row.name">
                {{
                  folderData.get(scope.row.id)
                    ? folderData.get(scope.row.id).length
                      ? formatTime(folderData.get(scope.row.id).length)
                      : '00:00'
                    : '...'
                }}
              </span>
              <span v-else>
                {{
                  scope.row.length ? formatDuration(scope.row.length) : '00:00'
                }}
              </span>
            </v-row>
          </template>
          <template slot-scope="scope" slot="iaCommon">
            <v-row
              no-gutters
              align="center"
              class="searchVideosMenuContext justify-end"
              @click="handleEnterFolder(scope.row)"
            >
              <span v-if="alreadyHasPandaAssistVideos.includes(scope.row.id)">
                <v-tag type="neutral">
                  {{ $t('message.pages.pandaAssist.createModal.alreadyHave') }}
                </v-tag>
              </span>
              <span class="mr-4" v-else-if="scope.row.original_lang">
                <v-tag type="success">
                  {{ $t('message.pages.pandaAssist.createModal.subtitle') }}
                  <v-icon
                    :color="$vuetify.theme.dark ? '#DCEFDD' : '#174F1B'"
                    class="ml-1"
                  >
                    panda-check-round
                  </v-icon>
                </v-tag>
              </span>

              <!-- Exibe a duração em minutos -->

              <span class="body-bold-smaller">
                <span v-if="alreadyHasPandaAssistVideos.includes(scope.row.id)">
                </span>
                <span
                  v-else-if="scope.row.original_lang"
                  class="body-bold-smaller textType5--text mr-2"
                >
                  0
                </span>
                <span v-else-if="scope.row.name" class="mr-2">
                  {{
                    folderData.get(scope.row.id)
                      ? folderData.get(scope.row.id).cost
                      : '...'
                  }}
                </span>
                <span v-else class="body-bold-smaller textType5--text mr-2">
                  {{ convertSecondsToMinutes(scope.row.length) }}
                </span>
              </span>
              <v-icon
                v-if="!alreadyHasPandaAssistVideos.includes(scope.row.id)"
                class="creditsIcon"
                size="16"
                >panda-ia-credits</v-icon
              >
            </v-row>
          </template>
        </vue-virtual-table>
        <div
          v-else
          style="height: 450px"
          class="empty-state d-flex align-center justify-center"
        >
          <span style="display: grid">
            <p class="body-regular-base d-flex justify-center mb-2">
              {{ $t('message.pages.pandaAssist.createModal.noItemsFound') }}
            </p>

            <p
              style="text-align: center"
              v-html="
                $t(
                  'message.pages.pandaAssist.createModal.noItemsFoundDescription'
                )
              "
              class="body-regular-small textType6--text"
            ></p>
          </span>
        </div>
      </div>
    </v-card>
    <v-card
      class="modalFooter d-flex justify-space-between"
      height="88px"
      flat
      v-if="step === 2"
    >
      <div>
        <base-btn
          :disabled="isLoading"
          type="tertiary"
          @click="finalize"
          class="mr-2"
        >
          {{ $t('message.pages.pandaAssist.createModal.cancel') }}
        </base-btn>
      </div>
      <div class="d-flex">
        <div style="display: grid">
          <span class="body-bold-smaller textType5--text ml-auto"
            >{{ $t('message.pages.pandaAssist.createModal.total') }}:
            <span class="ml-2">
              {{ totalMinutes }}
              <v-icon class="creditsIcon" size="16"
                >panda-ia-credits</v-icon
              ></span
            ></span
          >
          <span
            v-if="selectedItems.length === 0"
            class="body-regular-smaller textType6--text"
            >{{
              $t('message.pages.pandaAssist.createModal.noVideosSelected')
            }}</span
          >
          <span class="body-regular-smaller textType6--text" v-else>
            {{ videoSelectionText }}
          </span>
        </div>
        <base-btn
          :disabled="
            selectedItems.filter((item) => item.title).length === 0 || isLoading
          "
          type="primary"
          @click="confirmAndBuy"
          class="ml-6"
        >
          <template v-if="isLoading">
            <v-progress-circular indeterminate size="20" class="mr-2" />
            {{ $t('message.pages.pandaAssist.createModal.processing') }}
          </template>
          <template v-else>
            {{ $t('message.pages.pandaAssist.createModal.confirm') }}
          </template>
        </base-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import pandaAssist from '@/services/pandaAssist'
import { mapState, mapMutations } from 'vuex'
import creditsApi from '@/services/creditsApi'
import VueVirtualTable from 'vue-virtual-table'
import formatTimeMixin from '@/utils/formatTime.mixins.js'
import _ from 'lodash'
export default {
  components: { VueVirtualTable },
  name: 'SelectedPandaAssist',
  props: {
    openSelectPanda: {
      type: Boolean,
    },
  },
  mixins: [formatTimeMixin],
  data() {
    return {
      internalDialogVisible: this.openSelectPanda,
      step: 1,
      totalSteps: 2,
      name: '',
      initialQuestion: '',
      suggestionEnabled: false,
      dialogVisible: true,
      filteredItems: [],
      selectedItems: [],
      openCreatePandaAssist: false,
      videos: [
        { id: 1, name: 'Vídeo 1' },
        { id: 2, name: 'Vídeo 2' },
        { id: 3, name: 'Vídeo 3' },
      ],
      data: [],
      selectedVideos: [],
      searchQuery: '',
      pandaAssistSelected: '',
      fixedDateTime: null,
      isLoading: false,
      isConfirming: false,
      minRows: 1,
      maxRows: 4,
      alreadyHasPandaAssistVideos: [],
      articles: {
        pt: 'https://help.pandavideo.com/pt-br/article/pandaassist-ai-como-criar-chats-com-ia-nos-seus-videos-zdy32s/',
        en: 'https://help.pandavideo.com/en-us/article/pandaassist-ai-how-to-create-ai-chats-in-your-videos-r4624o/',
        es: 'https://help.pandavideo.com/es/article/pandaassist-ai-como-crear-chats-con-ia-en-tus-videos-1ewhd32/',
      },
      langOption: 'pt-BR',
      allVideos: [],
      totalMinutes: 0,
      items: [
        {
          text: this.$t('message.pages.pandaAssist.messages.portuguese'),
          value: 'pt-BR',
          icon: require('@/assets/brazil.svg'),
        },
        {
          text: this.$t('message.pages.pandaAssist.messages.english'),
          value: 'en',
          icon: require('@/assets/english.svg'),
        },
        {
          text: this.$t('message.pages.pandaAssist.messages.spanish'),
          value: 'es',
          icon: require('@/assets/spanish.svg'),
        },
      ],
      confirmValue: false,
      lastFolder: {
        name: '',
        id: null,
        parent_folder_id: null,
      },
      selectedFolder: null,
      searchFuseOptions: {
        keys: ['title', 'name', 'id', 'video_external_id', 'description'],
        includeScore: true,
        threshold: 0.4,
      },
      folderData: new Map(),
      purchaseOverviewData: [],
      flatItemList: [],
      accountBalance: 0,
      headers: [
        {
          prop: '_action',
          name: 'action',
          actionName: 'select',
          width: 45,
          alignItems: 'center',
          justifyContent: 'start',
        },
        {
          prop: '_action',
          name: 'title',
          actionName: 'titleCommon',
          width: 450,
        },
        {
          prop: '_action',
          name: 'goInto',
          actionName: 'durationCommon',
          width: 62,
          alignItems: 'center',
          justifyContent: 'end',
        },
        {
          prop: '_action',
          name: 'goInto',
          actionName: 'iaCommon',
          width: 196,
          alignItems: 'center',
          justifyContent: 'end',
        },
      ],
      breadcrumbArray: [{ name: '', id: null, parent_folder_id: null }],
    }
  },
  computed: {
    ...mapState({
      video: (state) => state.video.video,
      hasStatus: (state) => state.video.aiWorkFlow?.status,
      hasData: (state) => state.video.aiWorkFlow?.data,
      isEnabled: (state) => state.video.aiWorkFlow?.isEnabled,
    }),
    ...mapState('user', {
      folders: 'mainFolders',
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
    calculatedRows() {
      const lines = this.initialQuestion.split('\n').length
      return Math.min(Math.max(lines, this.minRows), this.maxRows)
    },
    embedArticle() {
      const lang = this.$i18next.language || this.$i18n?.locale || 'en'
      switch (lang) {
        case 'pt-BR':
        case 'pt':
          return this.articles.pt
        case 'es':
          return this.articles.es
        case 'en':
        default:
          return this.articles.en
      }
    },
    videoSelectionText() {
      const count = this.selectedItems.filter((item) => item.title).length
      return this.$t(
        count === 1
          ? 'message.pages.pandaAssist.createModal.videoSelected'
          : 'message.pages.pandaAssist.createModal.videosSelected',
        { count }
      )
    },
    completeItems() {
      return [...this.folders, ...this.allVideos]
    },
    currentIcon() {
      const selectedItem = this.items.find(
        (item) => item.value === this.langOption
      )
      return selectedItem ? selectedItem.icon : require('@/assets/brazil.svg')
    },
    reducedBreadcrumbArray() {
      let arrayMod = this.breadcrumbArray.filter((folder) => {
        return folder.id !== this.lastFolder.id
      })
      if (this.selectedFolder) {
        return this.breadcrumbArray
      }
      return arrayMod
    },
    areAllSelected() {
      const selectableItems = this.filteredItems.filter(
        (item) => !this.alreadyHasPandaAssistVideos.includes(item.id)
      )
      return (
        selectableItems.length > 0 &&
        selectableItems.every((item) =>
          this.selectedItems.some((selected) => selected.id === item.id)
        )
      )
    },
    checkboxIndeterminateStatus() {
      const selectableItems = this.filteredItems.filter(
        (item) => !this.alreadyHasPandaAssistVideos.includes(item.id)
      )
      const selectedCount = selectableItems.filter((item) =>
        this.selectedItems.some((selected) => selected.id === item.id)
      ).length

      return selectedCount > 0 && selectedCount < selectableItems.length
    },
    lastBreadcrumbItem() {
      return this.breadcrumbArray[this.breadcrumbArray.length - 1]
    },
    isNamesTooBig() {
      let size = 0
      for (let folder of this.breadcrumbArray) {
        size += folder.name.length
      }
      if (this.selectedFolder?.name) {
        size += this.selectedFolder.name.length
      }
      return size > 50
    },
    allItems() {
      return this.toBeSelectedFolders.concat(this.allVideos)
    },
    toBeSelectedFolders() {
      let selectedFolders = this.folders.filter((folder) => {
        return folder.parent_folder_id === this.lastFolder.id
      })
      return selectedFolders
    },
  },
  watch: {
    openSelectPanda(newVal) {
      this.internalDialogVisible = newVal
    },
    allItems: {
      immediate: true,
      handler(newItems) {
        this.filteredItems = newItems.filter(
          (item) => item.status !== 'DELETING' && item.status !== 'FAILED'
        )
      },
    },
    internalDialogVisible(newVal) {
      this.$emit('update:openSelectPanda', newVal)
    },
    step() {
      this.setFixedDateTime()
    },
    searchQuery(newQuery) {
      this.applyFilter(newQuery)
    },
    video_external_id() {
      this.filterByExternalID()
    },
  },
  methods: {
    ...mapMutations('user', [
      'UPDATE_GLOBAL_SNACKBAR',
      'UPDATE_GLOBAL_BASE_MODAL_MESSAGE',
    ]),
    formatDuration(seconds) {
      if (!seconds || seconds <= 0 || isNaN(seconds)) return ''

      const hrs = Math.floor(seconds / 3600)
      const mins = Math.floor((seconds % 3600) / 60)
      const secs = Math.floor(seconds % 60)

      if (hrs > 0) {
        return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(
          2,
          '0'
        )}:${String(secs).padStart(2, '0')}`
      } else {
        return `${String(mins).padStart(2, '0')}:${String(secs).padStart(
          2,
          '0'
        )}`
      }
    },
    convertSecondsToMinutes(seconds) {
      return Math.ceil(seconds / 60)
    },
    updateTotalMinutes() {
      this.totalMinutes = this.selectedItems.reduce((total, item) => {
        if (item.length) {
          const itemMinutes = Math.ceil(item.length / 60)
          if (!item.original_lang) {
            return total + itemMinutes
          }
        }
        return total
      }, 0)
    },
    handleClose() {
      this.closeModal()
      this.$emit('openModalChangeAssist', true)
    },
    selectOption(option) {
      this.pandaAssistSelected = option
      this.checkIfSelected(this.video)
      this.checkboxSelection(this.video)
      this.nextStep()
    },
    closeModal() {
      this.internalDialogVisible = false
      this.resetModal()
    },
    handleDialogClose(isVisible) {
      this.internalDialogVisible = isVisible
      if (!isVisible) {
        this.resetModal()
      }
    },
    async handleEnterFolder(item) {
      if (!item.name) {
        this.checkboxSelection(item)
      } else {
        this.allVideos = await window.db.videos
          .where({ folder_id: item.id })
          .toArray()
        this.lastFolder = item
        this.breadcrumbArray.push(item)
      }
    },
    checkIfHasChildren(folder) {
      let anySon = this.folders.find(
        (item) => item.parent_folder_id === folder.id
      )
      return anySon
    },
    async handleBackTo(backToFolder) {
      if (backToFolder.id) {
        this.allVideos = await window.db.videos
          .where({ folder_id: backToFolder.id })
          .toArray()
      } else {
        this.breadcrumbArray = [{ name: '', id: null, parent_folder_id: null }]
        this.getVideos()
      }
      this.selectedFolder = null
      this.lastFolder = backToFolder
      if (
        this.breadcrumbArray.length < 2 ||
        this.breadcrumbArray[this.breadcrumbArray.length - 1].id ===
          backToFolder.id
      )
        return
      let index = this.breadcrumbArray.findIndex((folder) => {
        return folder.id === backToFolder.id
      })
      let newArr = this.breadcrumbArray.slice(0, index + 1)
      this.breadcrumbArray = newArr
    },
    checkIfSelected(item) {
      let foundItem = this.selectedItems.find((searchedVideo) => {
        return searchedVideo.id === item.id
      })
      if (foundItem) return true
      return false
    },
    async checkboxSelection(item) {
      if (this.alreadyHasPandaAssistVideos.includes(item.id)) {
        return
      }

      const alreadySelected = this.checkIfSelected(item)

      if (item.name) {
        const allItemsInFolder = await this.getAllItemsInFolder(item.id)

        if (alreadySelected) {
          this.selectedItems = this.selectedItems.filter(
            (selectedItem) =>
              selectedItem.id !== item.id &&
              !allItemsInFolder.some((i) => i.id === selectedItem.id)
          )
        } else {
          const itemsToAdd = allItemsInFolder.filter(
            (i) =>
              !this.checkIfSelected(i) &&
              !this.alreadyHasPandaAssistVideos.includes(i.id)
          )
          this.selectedItems = [...this.selectedItems, item, ...itemsToAdd]
        }
      } else {
        if (alreadySelected) {
          this.selectedItems = this.selectedItems.filter(
            (selected) => selected.id !== item.id
          )
        } else {
          this.selectedItems.push(item)
        }
      }
      this.selectedItems = [...new Set(this.selectedItems)]
      this.updateTotalMinutes()
    },
    handleItemClick(item) {
      if (this.alreadyHasPandaAssistVideos.includes(item.id)) {
        return
      }
      this.handleEnterFolder(item)
    },
    async getAssistants() {
      const response = await pandaAssist.getAssistants()
      this.data = response.data.filter(
        (item) =>
          item.status !== 'deleted' &&
          item.status !== 'queued' &&
          item.status !== 'failed'
      )
      this.noCredits = this.data.some(
        (item) => item.status === 'payment_failed'
      )
      const videoIds = this.data
        .flatMap((item) => item.videos)
        .map((video) => video.id)

      this.pandaAssistVideos = videoIds
      console.log(this.pandaAssistVideos)
      this.alreadyHasPandaAssistVideos = this.pandaAssistVideos
      this.fetching = false
    },
    nextStep() {
      this.step += 1
    },
    async toggleSelectAll(isSelected) {
      const selectableItems = this.filteredItems.filter(
        (item) => !this.alreadyHasPandaAssistVideos.includes(item.id)
      )

      if (isSelected) {
        this.selectedItems = [
          ...new Set([...this.selectedItems, ...selectableItems]),
        ]
      } else {
        this.selectedItems = this.selectedItems.filter(
          (item) =>
            !selectableItems.some((selectable) => selectable.id === item.id)
        )
      }

      this.updateTotalMinutes()
    },
    toggleVideoSelection(videoId) {
      const index = this.selectedVideos.indexOf(videoId)
      if (index === -1) {
        this.selectedVideos.push(videoId)
      } else {
        this.selectedVideos.splice(index, 1)
      }
    },
    finalize() {
      console.log('Finalizado!', {
        name: this.name,
        initialQuestion: this.initialQuestion,
        suggestionEnabled: this.suggestionEnabled,
        selectedVideos: this.selectedVideos,
      })
      this.closeModal()
    },
    resetModal() {
      this.step = 1
      this.name = ''
      this.initialQuestion = ''
      this.suggestionEnabled = false
      this.selectedVideos = []
    },
    async getVideos() {
      this.allVideos = await window.db.videos
        .where({ folder_id: 'root' })
        .toArray()
      this.filterByExternalID()
    },
    async getFolderSize(
      folders,
      isSub = false,
      id = null,
      data = new Map(),
      visitedFolders = new Set()
    ) {
      for (const folder of folders) {
        if (visitedFolders.has(folder.id)) continue

        visitedFolders.add(folder.id)

        const videosIn = await window.db.videos
          .where({ folder_id: folder.id })
          .and(({ status }) => status !== 'DELETING')
          .toArray()

        let fData = { size: 0, length: 0, cost: 0 }

        for (const { storage_size, length } of videosIn) {
          fData.size += storage_size
          fData.length += length
          fData.cost += Math.ceil(length / 60)
        }

        if (!isSub) {
          data.set(folder.id, fData)
        } else {
          const parentData = data.get(id) || { size: 0, length: 0, cost: 0 }

          parentData.size += fData.size
          parentData.length += fData.length
          parentData.cost += fData.cost

          data.set(id, parentData)
        }

        const subFolders = this.folders.filter(
          ({ parent_folder_id }) => parent_folder_id === folder.id
        )

        if (subFolders.length) {
          await this.getFolderSize(
            subFolders,
            true,
            id ?? folder.id,
            data,
            visitedFolders
          )
        }
      }

      return data
    },
    async getCreditsInfo() {
      try {
        const { data } = await creditsApi.getCreditsBalance()
        this.accountBalance = data.balance
      } catch (error) {
        console.error('error', error)
      }
    },
    async filterByExternalID() {
      if (!this.video_external_id) return

      const option = { video_external_id: this.video_external_id }

      const [videoInDB] = await window.db.videos.where(option).toArray()
      const videoInRoot = _.find(this.allVideos, option)

      let video

      if (videoInRoot) video = videoInRoot
      else {
        this.allVideos.push(videoInDB)
        video = videoInDB
      }

      this.selectedItems = [video]

      this.handleFilterSelected()
    },
    async nextStepOverview() {
      if (this.langOption === 'pt') {
        this.langOption = 'pt-BR'
      }

      this.isLoading = true
      try {
        const selectedIds = this.selectedItems
          .filter((item) => item.title)
          .map((item) => item.id)

        const response = await pandaAssist.purchaseOverview({
          videoIds: selectedIds,
          lang: this.langOption,
        })

        this.purchaseOverviewData = response.data
        this.step += 1
      } catch (error) {
        console.error('Erro ao carregar dados:', error)
      } finally {
        this.isLoading = false
      }
    },
    async confirmAndBuy() {
      if (this.$i18next.language === 'pt') {
        this.langOption = 'pt-BR'
      }
      this.isLoading = true
      this.isConfirming = true

      try {
        const existingVideoIds =
          this.pandaAssistSelected?.videos?.map((video) => video.id) || []
        const selectedVideoIds = this.selectedItems
          .filter((item) => item.title)
          .map((item) => item.id)
        const allVideoIds = [
          ...new Set([...existingVideoIds, ...selectedVideoIds]),
        ]
        await pandaAssist.updateAssistantVideoBind(
          this.pandaAssistSelected?.id,
          {
            videoIds: allVideoIds,
            lang: this.langOption || this.$i18next.language,
          }
        )

        this.isLoading = false
        this.$emit('buyConfirm', true)

        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          type: 'success',
          text: this.$t('message.assistSuccess'),
        })

        this.closeModal()
      } catch (error) {
        console.error('Erro ao realizar a compra:', error)
      } finally {
        this.isConfirming = false
      }
    },
    updateLocalizedTexts() {
      this.messages = [
        this.$t('message.pages.pandaAssist.messages.internalAssistant'),
        this.$t('message.pages.pandaAssist.messages.salesVSL'),
        this.$t('message.pages.pandaAssist.messages.knowledgeBase'),
        this.$t('message.pages.pandaAssist.messages.prepareStudents'),
        this.$t('message.pages.pandaAssist.messages.instantAnswers'),
      ]
      this.items = [
        {
          text: this.$t('message.pages.pandaAssist.messages.portuguese'),
          value: 'pt-BR',
          icon: require('@/assets/brazil.svg'),
        },
        {
          text: this.$t('message.pages.pandaAssist.messages.english'),
          value: 'en',
          icon: require('@/assets/english.svg'),
        },
        {
          text: this.$t('message.pages.pandaAssist.messages.spanish'),
          value: 'es',
          icon: require('@/assets/spanish.svg'),
        },
      ]
      this.messageKey = 0
      this.currentMessage = this.messages[this.messageKey]
    },
    goToExtract() {
      this.$router.push({ name: 'Credits' }).catch(() => {})
    },
    updateRows() {
      this.$nextTick(() => {
        const textarea = this.$refs.textarea?.$el.querySelector('textarea')
        if (textarea) {
          textarea.style.height = 'auto'
          textarea.style.height = `${textarea.scrollHeight}px`
        }
      })
    },
    setFixedDateTime() {
      if (!this.fixedDateTime) {
        const now = new Date()

        const locale = this.$i18n?.locale || this.$i18next?.language || 'pt-BR'

        const dateFormatter = new Intl.DateTimeFormat(locale, {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })

        const timeFormatter = new Intl.DateTimeFormat(locale, {
          hour: '2-digit',
          minute: '2-digit',
        })

        const formattedDate = dateFormatter.format(now)
        const formattedTime = timeFormatter.format(now)

        const translationMap = {
          'pt-BR': 'às',
          en: 'at',
          es: 'a las',
        }

        const atTranslation = translationMap[locale] || 'às'

        this.fixedDateTime = `${formattedDate} ${atTranslation} ${formattedTime}`
      }
    },

    async flattenAllItems() {
      let allItems = []
      allItems.push(...this.folders)
      const videos = await window.db.videos
        .filter(({ status }) => status !== 'DELETING')
        .toArray()
      allItems.push(...videos)

      return allItems
    },
    openCredits() {
      this.$router.push({ name: 'Credits' }).catch(() => {})
    },

    remainingBalance() {
      return this.accountBalance - this.purchaseOverviewData.total_credit_cost
    },

    applyFilter(query) {
      const lowerQuery = query.toLowerCase()
      this.filteredItems = this.allItems.filter((item) => {
        const name = item.name ? item.name.toLowerCase() : ''
        const title = item.title ? item.title.toLowerCase() : ''

        if (item.title) {
          return item.status === 'CONVERTED' && title.includes(lowerQuery)
        }

        if (item.name) {
          return name.includes(lowerQuery)
        }
        return false
      })
    },

    handleSelectedItem(item) {
      if (!this.checkIfSelected(item)) {
        this.selectedItems.push(item)
      }
    },

    handleFolderSelected(folder) {
      this.lastFolder = folder
      this.breadcrumbArray.push(folder)
    },

    backStep() {
      this.step -= 1
    },

    goToPandaAssist() {
      this.closeModal()
      this.$root.$emit('goToPandaAssist')
    },

    async handleEmitAll() {
      this.selectedItems = []
      this.isShown = false
      this.$root.$emit('analyticsV2SearchAll')
    },
    async handleFilterSelected() {
      let videos = []
      let folders = []
      for (let item of this.selectedItems) {
        if (item.name) {
          folders.push(item)
        } else {
          videos.push(item)
        }
      }
      this.filteredVideos = [...videos]
      let result = await this.getAllItems(folders)
      this.filteredVideos = this.filteredVideos.concat(result)
      this.$root.$emit('filterSelected', this.filteredVideos)
      this.filteredVideos = []
      this.isShown = false
    },
    async getAllItems(folders) {
      let items = []
      for (let item of folders) {
        if (item.name) {
          let vids = await window.db.videos
            .where({ folder_id: item.id })
            .toArray()
          items = items.concat(vids)
          let children = this.folders.filter(
            (folder) => folder.parent_folder_id === item.id
          )
          if (children.length) {
            await this.getAllItems(children)
          }
        }
      }
      return items
    },
  },
  async created() {
    if (this.$i18next.language === 'pt-BR' || this.$i18next.language === 'pt') {
      this.langOption = 'pt-BR'
    } else if (this.$i18next.language === 'en') {
      this.langOption = 'en'
    } else if (this.$i18next.language === 'es') {
      this.langOption = 'es'
    }
    if (!window.db) {
      this.$root.$emit('initDexie')
    }
    this.getCreditsInfo()
    this.getVideos()
    this.folderData = await this.getFolderSize(this.folders)
  },
  async mounted() {
    this.getAssistants()
    this.$root.$on('changeLanguage', () => {
      this.updateLocalizedTexts()
    })
    this.flatItemList = await this.flattenAllItems()
  },
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/src/data-tableV2';
.selected-video {
  background-color: #e0f7fa !important;
}

.assistHeadline {
  white-space: normal;
  word-break: break-word;
}

.step-indicators {
  display: flex;
  gap: 8px;
}

::v-deep .item-line {
  border-top: 1px solid varFigma(neutral-95-lightest) !important;
}

.checkoutStep {
  height: 100%;
}

.chatPreview {
  width: 327px;
  overflow: auto;
  height: 211px;
  margin: 0 auto;
  background: #282931;
  border-radius: 8px;
  border: 1px solid varFigma(neutral-80-lighter);
}

.negativeCreditsIcon {
  color: varFigma(feedback-danger-light) !important;
}

.dangerCreditsText {
  color: varFigma(feedback-danger) !important;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
  display: inline-block;
}

.checkoutDesc {
  background: varFigma(neutral-background);
}

.checkoutPayment {
  background: varFigma(neutral-100-white);

  /* shadow */
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);
}

.modalFooter {
  position: sticky;
  bottom: 0;
  width: 100%;
  z-index: 10;
  border-top: 1px solid varFigma(brand-95-lighter);
  background: varFigma(neutral-99);
  padding: 24px 28px;
}

.checkoutFooter {
  position: sticky;
  display: grid;
  bottom: 0;
  width: 100%;
  z-index: 10;
  border-top: 1px solid varFigma(neutral-95-lightest);
  background: varFigma(brand-99-lightest);
}

::v-deep .panda-search:before {
  font-size: 16px !important;
}

.base-input.v-input[data-v-36a1b07e] input::placeholder {
  font-weight: 400;
  font-size: 12px;
}

.v-dialog--fullscreen > .v-card {
  min-height: auto !important;
  min-width: 100%;
  margin: 0 !important;
  padding: 16px;
}
.border-neutral-95 {
  border-color: varFigma(neutral-95-lightest) !important;
}
.color-neutral-40-light {
  color: varFigma(neutral-40-light) !important;
}
.step-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: varFigma(neutral-80-lighter);
  transition: background 0.3s ease;
}

::v-deep .v-label {
  font-size: 14px !important;
  color: varFigma(neutral-40-light) !important;
}

.extractBtn {
  color: varFigma(brand-60-base);
}

.tableArrow {
  color: varFigma(neutral-20-dark) !important;
}

.step-indicator.active {
  background: varFigma(brand-60-base); /* Cor para o passo ativo */
}

.message-box {
  display: block;
  color: #636578 !important;
  z-index: 999;
  position: relative;
}

.folderIcon {
  color: varFigma(neutral-70) !important;
}

.videoIcon {
  color: varFigma(brand-70) !important;
}

.videoIconNeutral {
  color: varFigma(neutral-70) !important;
}

.creditsIcon {
  color: varFigma(brand-70) !important;
}

.bg-dark {
  .message-box {
    color: #b9bbc6 !important;
  }
}

.questionSugestion {
  color: #636578;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 16.5px */
  letter-spacing: 0.66px;
  text-transform: uppercase;
}

::v-deep .panda-assist-dialog {
  background: varFigma(neutral-100-white) !important;
}
.selected-video {
  background-color: #e0f7fa !important;
}
.assistHeadline {
  white-space: normal;
  word-break: break-word;
}
.step-indicators {
  display: flex;
  gap: 8px;
}
.step-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: varFigma(neutral-80-lighter);
  transition: background 0.3s ease;
}
.step-indicator.active {
  background: varFigma(brand-60-base); /* Cor para o passo ativo */
}
.questionSugestion {
  color: #636578;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 16.5px */
  letter-spacing: 0.66px;
  text-transform: uppercase;
}
::v-deep .panda-assist-dialog {
  background: varFigma(neutral-100-white) !important;
}
</style>
